"use client";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function CustomNotify() {
  return (
    <ToastContainer
      autoClose={4000}
      position="top-right"
      toastClassName="!bg-slate-800"
      closeButton
      toastStyle={{
        maxWidth: "95%",
      }}
    />
  );
}

export default CustomNotify;
